export default {
  meta: {
    title: $localize`:@@meta.wheel.history.title:История Crazy Wheel`,
    description: $localize`:@@meta.wheel.history.desc:Охотишься за сочными скинами или крупными выигрышами? Что ж, убедись в самых лучших коэффициентах из всех double CS:GO на этой странице`
  }
};